import React, { useEffect, useState } from 'react';
import useWindowDimensions from '../../helpers/useWindowDimensions';
import styles from "../../styles/Components/Shared/Paginate.module.css";

import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Paginate  = ({
    paginateProps: {
        paginationPage, 
        setPaginationPage, 
        count, 
        pageSize, 
        getContent, 
        hide 
    }
   
}) => { 

    const [totalPages, setTotalPages] = useState(0)
    
    useEffect(() => {
        const totalPages = Number.isInteger(count/pageSize) ? count/pageSize : Math.floor(count/pageSize) + 1

        setTotalPages(totalPages)
    }, [count, pageSize])

    const { width } = useWindowDimensions()
    
    // const maxPageNumbersToShow = width > 750 ? 5 : width > 650 ? 3 : width > 500 ? 2 : 1; 
    const maxPageNumbersToShow = width > 750 ? 5 : width > 650 ? 3 : 2; 

    const handlePaginationClick = (pageNum) => {
        setPaginationPage(pageNum)

        if (getContent) {
            getContent(pageNum - 1)
        }
    }

    const handlePaginationPrevNext = (type) => {
        let realPage = paginationPage
        let pageNum = paginationPage
        if (type === 'prev') {
            realPage = paginationPage - 1
            pageNum = paginationPage - 2
        } else if (type === 'next') {
            realPage = paginationPage + 1
            pageNum = paginationPage
        }
        
        setPaginationPage(realPage)

        if (getContent) {
            getContent(pageNum)
        }
    }



    const handlePaginationNumbers = () => {
        let numbersArr = [];
        const halfWindow = Math.floor(maxPageNumbersToShow / 2);
        let startPage = Math.max(paginationPage - halfWindow, 1);
        let endPage = Math.min(startPage + maxPageNumbersToShow - 1, totalPages);
        
        // Get Start Page Number
        if (endPage === totalPages) {
            startPage = Math.max(1, totalPages - maxPageNumbersToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            numbersArr.push(
                <p key={`page-${i}`} className={paginationPage === i ? styles.selected_page : styles.not_selected_page} onClick={() => handlePaginationClick(i)}>
                    {i}
                </p>
            );
        }

        if (startPage > 2) {
            numbersArr = [
                <p className={styles.not_selected_page} onClick={() => handlePaginationClick(1)} key={`page-1`}>
                    1
                </p>,
                <p className={`${styles.not_selected_page} ${styles.paginate_ellipsis}`} key={`ellipsis`}>...</p>,
                ...numbersArr,
            ]
        } else if (startPage > 1) {
            numbersArr = [
                <p className={styles.not_selected_page} onClick={() => handlePaginationClick(1)} key={'first'}>
                    1
                </p>,
                ...numbersArr,
            ]
        }

        // Add ... elipsis and last page
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                numbersArr.push(<p key="ellipsis-2" className={`${styles.not_selected_page} ${styles.paginate_ellipsis}`}>...</p>);
            }
            numbersArr.push(
                <p key={`page-${totalPages}`} className={paginationPage === totalPages ? styles.selected_page : styles.not_selected_page} onClick={() => handlePaginationClick(totalPages)}>
                    {totalPages}
                </p>
            );
        }

        return numbersArr;
    };


    return (
        <div className={styles.pagination_main_container}>
            {/* Previous Button */}
            <div 
                className={styles.pagination_prev_container} 
                onClick={() => totalPages > 1 && paginationPage > 1 ? handlePaginationPrevNext('prev') : {}} 
                style={paginationPage <= 1 ? {cursor: 'not-allowed'} : {cursor: 'pointer'}}
            >
                <IoIosArrowBack size={30} style={{ color: 'white'}} />
                <p className={styles.pagination_next_prev_button_text}>Prev</p>
            </div>
            {/* Page Numbers */}
            <div className={styles.content_feed_numbers}>
                {handlePaginationNumbers()}
            </div>
            {/* Next Button */}
            <div 
                className={styles.pagination_next_container} 
                onClick={  () => totalPages > 1 && paginationPage < totalPages ? handlePaginationPrevNext('next') : {}} 
                style={paginationPage >= totalPages ? {cursor: 'not-allowed'} : {cursor: 'pointer'}}
            >
                <p className={styles.pagination_next_prev_button_text}>Next</p>
                <IoIosArrowForward size={30} style={{ color: 'white'}}/>
            </div>
        </div>
    )
}

export default Paginate;